import { ReactElement } from 'react';

import { DialogServiceAccreditation, Endpoint, getFilterDates, Route, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { FilterAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnClear, OnClick, OnDynamicContentRender, OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { ClearEvent, MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { Accreditation } from '../accreditation/provider-accreditation-controller';
import BaseController from '../BaseController';

import { CallsData, getStampByStatus } from './calls-utils';

interface Call {
  nrSeqCall: number;
  dsStatus: string;
  dsJustificationCloseCall: string;
  nrSequenceCallType: number;
  guidance: string;
}
@Controller({ fragment: 'calls' })
class CallsController extends BaseController {

  @OnClick('action-new-call')
  onClickNewCalled(): void {
    const { nrSeqUser } = this.historyService.getCurrentRouteParams();

    HttpService.get<Accreditation>(Endpoint.GET.ACCREDITATION_AUTOCOMPLETE, { nrSeqUser }).then((resp) => {
      if (isEmptyArrayOrObject(resp.body)) {
        DialogServiceAccreditation.alert(MessageService.translate('pa.required-opened-accreditation'));
        return;
      }
      this.historyService.push(Route.CALL_CATEGORY);
    }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

  @OnClear('filter-calls')
  onClearFilter(event: ClearEvent): void {
    const api = event.target as unknown as FilterAPI;
    api.setData(getFilterDates());
  }

  @OnMount('filter-calls')
  onMountFilterCalls(event: MountEvent): void {
    const { target } = event;
    const api = target as unknown as FilterAPI;
    const { dtOpenning, dtClose } = getFilterDates();
    api.setData({
      dtOpenning: dtOpenning,
      dtClose: dtClose,
    });
  }

  @OnDynamicContentRender('hpms-custom-card-calls')
  onDynamicContentRenderCardCall(event: RenderEvent): void {
    const { data, render } = event;
    const { cdStatus, dsStatus } = data as CallsData;
    const content = (): ReactElement => (getStampByStatus(cdStatus, dsStatus));
    render(content);
  }

  @OnSelectItem('deck-calls')
  public onSelectItemCall(event: SelectItemEvent<Record<string, Value>>): void {
    const data = event.item as unknown as Call;
    this.details(data.nrSeqCall);

  }

  private details(nrSeqCall: number): void {
    this.historyService.push(Route.DETAILS_CALLED, { nrSeqCall });
  }
}
export {
  CallsController,
  Call,
};
